// src/components/DeleteView.js
import React, { useState } from 'react';
import { deleteView } from '../services/database';

const DeleteView = ({ viewId, onClose, onDelete }) => {
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    try {
      await deleteView(viewId);
      onDelete(viewId);
      onClose();
    } catch (err) {
      console.error('Error deleting view:', err);
      setError(
        err?.response?.data?.message || 'Unable to delete view. Please try again.'
      );
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-md shadow-lg max-w-sm w-full mx-4">
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <h3 className="text-xl font-semibold mb-4">Confirm Deletion</h3>
        <p>Are you sure you want to delete this view?</p>
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md border hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteView;